import { AssignerHintsDto } from "app/ApiClient";
import { LoadingState } from "types";

export type AssignersState = {
  loading: LoadingState;
  data: AssignerHintsDto | null;
};
export const initialAssignersState: AssignersState = {
  loading: LoadingState.idle,
  data: null,
};
